import React from "react";
import { Box, Button, Tooltip } from "@material-ui/core";
import ConfiguracionColoresUmbral from "./ConfiguracionColoresUmbral";
import { withTranslation } from 'react-i18next';

function BtnConfiguracionColores({ t }) {
    const [showModal, setShowModal] = React.useState(false);

    return (
        <Box display="flex" justifyContent="end">
            <Tooltip title={t('thresholdConfig.button.tooltip')}>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setShowModal(true)}
                >
                    {t('thresholdConfig.button.label')}
                </Button>
            </Tooltip>
            {showModal && (
                <ConfiguracionColoresUmbral
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
}

export default withTranslation()(BtnConfiguracionColores);
